import {
  TIPTAP_ACTION_BUTTON_TYPE,
  TIPTAP_APP_EMBED_TYPE,
  TIPTAP_AUDIO_TYPE,
  TIPTAP_CODE_BLOCK_TYPE,
  TIPTAP_COLLAPSIBLE_LIST_TYPE,
  TIPTAP_DIVIDER_TYPE,
  TIPTAP_EMBED_TYPE,
  TIPTAP_FILE_TYPE,
  TIPTAP_GALLERY_TYPE,
  TIPTAP_GIF_TYPE,
  TIPTAP_HTML_TYPE,
  TIPTAP_IMAGE_TYPE,
  TIPTAP_LINK_BUTTON_TYPE,
  TIPTAP_LINK_PREVIEW_TYPE,
  TIPTAP_POLL_TYPE,
  TIPTAP_TABLE_TYPE,
  TIPTAP_VIDEO_TYPE,
} from 'ricos-content';
import {
  ACTION_BUTTON_TYPE,
  AUDIO_TYPE,
  CODE_BLOCK_TYPE,
  COLLAPSIBLE_LIST_TYPE,
  DIVIDER_TYPE,
  EMBED_TYPE,
  EXTERNAL,
  FILE_UPLOAD_TYPE,
  GALLERY_TYPE,
  GIPHY_TYPE,
  HTML_TYPE,
  IMAGE_TYPE,
  LINK_BUTTON_TYPE,
  LINK_PREVIEW_TYPE,
  POLL_TYPE,
  RICOS_ACTION_BUTTON_TYPE,
  RICOS_COLLAPSIBLE_LIST_TYPE,
  RICOS_DIVIDER_TYPE,
  RICOS_FILE_TYPE,
  RICOS_GALLERY_TYPE,
  RICOS_GIPHY_TYPE,
  RICOS_HTML_TYPE,
  RICOS_IMAGE_TYPE,
  RICOS_LINK_BUTTON_TYPE,
  RICOS_LINK_PREVIEW_TYPE,
  RICOS_POLL_TYPE,
  RICOS_TABLE_TYPE,
  RICOS_VERTICAL_EMBED_TYPE,
  RICOS_VIDEO_TYPE,
  TABLE_TYPE,
  VERTICAL_EMBED_TYPE,
  VIDEO_TYPE,
} from 'wix-rich-content-common';

export const TIPTAP_TYPE_TO_RICOS_TYPE = {
  [TIPTAP_DIVIDER_TYPE]: RICOS_DIVIDER_TYPE,
  [TIPTAP_IMAGE_TYPE]: RICOS_IMAGE_TYPE,
  [TIPTAP_GALLERY_TYPE]: RICOS_GALLERY_TYPE,
  [TIPTAP_FILE_TYPE]: RICOS_FILE_TYPE,
  [TIPTAP_GIF_TYPE]: RICOS_GIPHY_TYPE,
  [TIPTAP_VIDEO_TYPE]: RICOS_VIDEO_TYPE,
  [TIPTAP_AUDIO_TYPE]: AUDIO_TYPE,
  [TIPTAP_POLL_TYPE]: RICOS_POLL_TYPE,
  [TIPTAP_APP_EMBED_TYPE]: RICOS_VERTICAL_EMBED_TYPE,
  [TIPTAP_COLLAPSIBLE_LIST_TYPE]: RICOS_COLLAPSIBLE_LIST_TYPE,
  [TIPTAP_HTML_TYPE]: RICOS_HTML_TYPE,
  [TIPTAP_LINK_BUTTON_TYPE]: RICOS_LINK_BUTTON_TYPE,
  [TIPTAP_ACTION_BUTTON_TYPE]: RICOS_ACTION_BUTTON_TYPE,
  [TIPTAP_LINK_PREVIEW_TYPE]: RICOS_LINK_PREVIEW_TYPE,
  [TIPTAP_EMBED_TYPE]: EMBED_TYPE,
  text: 'text',
  [EXTERNAL]: [EXTERNAL],
};

export const TO_TIPTAP_TYPE = {
  [RICOS_DIVIDER_TYPE]: TIPTAP_DIVIDER_TYPE,
  [DIVIDER_TYPE]: TIPTAP_DIVIDER_TYPE,
  [RICOS_IMAGE_TYPE]: TIPTAP_IMAGE_TYPE,
  [IMAGE_TYPE]: TIPTAP_IMAGE_TYPE,
  [GALLERY_TYPE]: TIPTAP_GALLERY_TYPE,
  [RICOS_GALLERY_TYPE]: TIPTAP_GALLERY_TYPE,
  [FILE_UPLOAD_TYPE]: TIPTAP_FILE_TYPE,
  [RICOS_FILE_TYPE]: TIPTAP_FILE_TYPE,
  [GIPHY_TYPE]: TIPTAP_GIF_TYPE,
  [RICOS_GIPHY_TYPE]: TIPTAP_GIF_TYPE,
  [VIDEO_TYPE]: TIPTAP_VIDEO_TYPE,
  [AUDIO_TYPE]: TIPTAP_AUDIO_TYPE,
  [RICOS_VIDEO_TYPE]: TIPTAP_VIDEO_TYPE,
  [RICOS_POLL_TYPE]: TIPTAP_POLL_TYPE,
  [POLL_TYPE]: TIPTAP_POLL_TYPE,
  [VERTICAL_EMBED_TYPE]: TIPTAP_APP_EMBED_TYPE,
  [RICOS_VERTICAL_EMBED_TYPE]: TIPTAP_APP_EMBED_TYPE,
  [RICOS_COLLAPSIBLE_LIST_TYPE]: [TIPTAP_COLLAPSIBLE_LIST_TYPE],
  [COLLAPSIBLE_LIST_TYPE]: [TIPTAP_COLLAPSIBLE_LIST_TYPE],
  [HTML_TYPE]: TIPTAP_HTML_TYPE,
  [RICOS_HTML_TYPE]: TIPTAP_HTML_TYPE,
  [RICOS_ACTION_BUTTON_TYPE]: TIPTAP_ACTION_BUTTON_TYPE,
  [RICOS_LINK_BUTTON_TYPE]: TIPTAP_LINK_BUTTON_TYPE,
  [LINK_PREVIEW_TYPE]: TIPTAP_LINK_PREVIEW_TYPE,
  [RICOS_LINK_PREVIEW_TYPE]: TIPTAP_LINK_PREVIEW_TYPE,
  [EMBED_TYPE]: TIPTAP_EMBED_TYPE,
  [CODE_BLOCK_TYPE]: TIPTAP_CODE_BLOCK_TYPE,
  [ACTION_BUTTON_TYPE]: TIPTAP_ACTION_BUTTON_TYPE,
  [LINK_BUTTON_TYPE]: TIPTAP_LINK_BUTTON_TYPE,
  [TABLE_TYPE]: [TIPTAP_TABLE_TYPE],
  [RICOS_TABLE_TYPE]: [TIPTAP_TABLE_TYPE],
  [EXTERNAL]: [EXTERNAL],
};
